import ProgramacaoActionTypes from "./action-types.ts";

export const programacaoState = (payload) => ({
    type: ProgramacaoActionTypes.PROGRAMACAO,
    payload,
});